// extracted by mini-css-extract-plugin
module.exports = {"spacer":"RotatingTitle_spacer__1UbGr","slot":"RotatingTitle_slot__R_aI0","line":"RotatingTitle_line__aKLL4","snapping":"RotatingTitle_snapping__Z3odO"};